import styled from '@emotion/styled';

export const TabGroupContainer = styled.div`
  width: 100%;
`;
